import { FtlRoutingViewModel } from "../../../ViewModel/FtlRoutingViewModel";
import { RoutingType } from "../../../ViewModel/RoutingType";

export const getListOfOdcsFromRoutingTable = (routingTable: FtlRoutingViewModel[] | undefined) => {
  const listOfOCD: Array<string> = [];
  routingTable?.forEach((routing: FtlRoutingViewModel) => {
    if (routing.RoutingType === RoutingType.ODC) {
      if (routing?.Gsdb) {
        listOfOCD.push(routing?.Gsdb);
      }
    }
  });
  return listOfOCD;
};
